export const ApiBaseUrl = "https://admin.doctorrhynor.com";
export const ImgBaseUrl = "https://admin.doctorrhynor.com/";

// https://godoctor.cscodetech.cloud
